import { Accordion, AccordionDetails, AccordionSummary, Paper, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React, { useMemo } from "react";
import dayjs from "dayjs";
import { ChasableHistoryModel } from "@attelas/shared";

type Props = {
  title: string;
  emptyText: string;
  history: ChasableHistoryModel[];
};

export function History({ title, emptyText, history }: Props) {
  const sortedHistory = useMemo(() => {
    return [...history].sort((a, b) => {
      const dateA = dayjs(a.date);
      const dateB = dayjs(b.date);

      if (!dateA.isValid() && !dateB.isValid()) return 0;
      if (!dateA.isValid()) return 1;
      if (!dateB.isValid()) return -1;
      return dateB.valueOf() - dateA.valueOf();
    });
  }, [history]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<KeyboardArrowDownIcon />}
        aria-controls="information-panel-content"
        id="information-panel"
      >
        <Typography variant="h3">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Paper sx={{ padding: 2, maxHeight: "250px", overflowY: "auto" }}>
          {sortedHistory.length === 0 ? (
            <Typography variant="body1">{emptyText}</Typography>
          ) : (
            <>
              {sortedHistory.map((historyItem, index) => {
                const date = dayjs(historyItem.date);
                return (
                  <div key={index}>
                    <Typography variant="body1">
                      <strong>
                        {date.isValid()
                          ? Intl.DateTimeFormat(Office.context.displayLanguage, { dateStyle: "long" }).format(
                              date.toDate()
                            )
                          : "Invalid Date"}
                      </strong>{" "}
                      - {historyItem.detail}
                    </Typography>
                  </div>
                );
              })}
            </>
          )}
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
}
